/** @jsx jsx */
import PropTypes from 'prop-types'
import { jsx } from 'theme-ui'

const CustomTable = ({ data, id }) => {
  const { table } = data.fields
  const tableHead = table?.tableData && table?.tableData.slice(0, 1)
  const tableContents = table?.tableData && table?.tableData.slice(1)
  return (
    <table id={id} sx={{ marginBottom: '24px' }}>
      <thead>
        <tr>
          {tableHead &&
            tableHead[0] &&
            tableHead[0].map((tableHead, i) => {
              return <td key={`${tableHead}-${i}`}>{tableHead}</td>
            })}
        </tr>
      </thead>
      <tbody>
        {tableContents &&
          tableContents.map((tableContent, i) => {
            return (
              <tr key={`${tableContent}-${i}`}>
                {tableContent &&
                  tableContent.map((row, i) => {
                    return <td key={`${row}-${i}`}>{row}</td>
                  })}
              </tr>
            )
          })}
      </tbody>
    </table>
  )
}

CustomTable.propTypes = {
  data: PropTypes.object.isRequired,
  id: PropTypes.string.isRequired,
}

export default CustomTable
